export default __webpack_public_path__ + "static/media/cashRegisterSFX.3f44ed91.mp3";